"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_CHALLENGE_VALUE = 'SET_CHALLENGE_VALUE';
exports.RESET_CHALLENGE_VALUE = 'RESET_CHALLENGE_VALUE';



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/store/challenges/types.ts
// module id = 373
// module chunks = 5